export default __webpack_public_path__ + "static/imgAboutUspng-d9393c6454f703a7a3efa8e7d29d1ab0.png";